export const baseURL = process.env.REACT_APP_BASEURL;
export const env = process.env.NODE_ENV;
export const serverAddress = new URL(process.env.REACT_APP_BASEURL || "");
